var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('icon-home'),_c('icon-todo'),_c('icon-habit'),_c('icon-other')],1)}
var staticRenderFns = []

export { render, staticRenderFns }